<footer
  class="mt-auto border-t-2 border-amber-500/30 bg-slate-950"
  [class.hidden]="desktopOnly()"
  [class.lg:block]="desktopOnly()">
  <div class="tfr-page-shell pt-12 pb-8">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-10 mb-10">
      <div>
        <p class="text-[11px] font-bold uppercase tracking-[0.14em] text-amber-100/90 mb-4">Plataforma</p>
        <nav class="flex flex-col gap-2.5">
          <a routerLink="/explorar" class="text-[13px] text-zinc-400 transition-colors hover:text-amber-200">Explorar espacios</a>
          <a routerLink="/propietarios" class="text-[13px] text-zinc-400 transition-colors hover:text-amber-200">Publicar tu espacio</a>
          <a routerLink="/mis-reservas" class="text-[13px] text-zinc-400 transition-colors hover:text-amber-200">Mis reservas</a>
          <a routerLink="/dashboard" class="text-[13px] text-zinc-400 transition-colors hover:text-amber-200">Panel de control</a>
        </nav>
      </div>
      <div>
        <p class="text-[11px] font-bold uppercase tracking-[0.14em] text-amber-100/90 mb-4">Recursos</p>
        <nav class="flex flex-col gap-2.5">
          <span class="text-[13px] text-zinc-500">Blog (próximamente)</span>
          <span class="text-[13px] text-zinc-500">Centro de ayuda</span>
          <span class="text-[13px] text-zinc-500">Documentación API</span>
          <a routerLink="/explorar" class="text-[13px] text-zinc-400 transition-colors hover:text-amber-200">Catálogo público</a>
        </nav>
      </div>
      <div>
        <p class="text-[11px] font-bold uppercase tracking-[0.14em] text-amber-100/90 mb-4">Empresa</p>
        <nav class="flex flex-col gap-2.5">
          <span class="text-[13px] text-zinc-500">Sobre TimeFlexRent</span>
          <span class="text-[13px] text-zinc-500">Contacto</span>
          <span class="text-[13px] text-zinc-500">Prensa</span>
          <span class="text-[13px] text-zinc-500">Trabaja con nosotros</span>
        </nav>
      </div>
      <div>
        <p class="text-[11px] font-bold uppercase tracking-[0.14em] text-amber-100/90 mb-4">Ayuda</p>
        <nav class="flex flex-col gap-2.5">
          <span class="text-[13px] text-zinc-500">Preguntas frecuentes</span>
          <span class="text-[13px] text-zinc-500">Soporte</span>
          <a routerLink="/privacidad" class="text-[13px] text-zinc-400 transition-colors hover:text-amber-200">Privacidad</a>
          <a routerLink="/terminos" class="text-[13px] text-zinc-400 transition-colors hover:text-amber-200">Términos generales</a>
          <a routerLink="/terminos-propietarios" class="text-[13px] text-zinc-400 transition-colors hover:text-amber-200">Términos propietarios</a>
          <a routerLink="/desistimiento" class="text-[13px] text-zinc-400 transition-colors hover:text-amber-200">Derecho de desistimiento</a>
        </nav>
      </div>
    </div>
    <div class="border-t border-zinc-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
      <p class="text-[13px] text-zinc-500">&copy; 2026 TimeFlexRent &middot; Todos los derechos reservados</p>
      <nav class="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
        <a routerLink="/privacidad" class="text-[12px] text-zinc-400 transition-colors hover:text-amber-200">Aviso legal</a>
        <a routerLink="/privacidad" class="text-[12px] text-zinc-400 transition-colors hover:text-amber-200">Privacidad</a>
        <a routerLink="/terminos" class="text-[12px] text-zinc-400 transition-colors hover:text-amber-200">T&amp;C generales</a>
        <a routerLink="/terminos-propietarios" class="text-[12px] text-zinc-400 transition-colors hover:text-amber-200">T&amp;C propietarios</a>
        <a routerLink="/desistimiento" class="text-[12px] text-zinc-400 transition-colors hover:text-amber-200">Desistimiento</a>
      </nav>
    </div>
  </div>
</footer>
